import React from "react";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

function PaymentGatewayRspV2() {
  let url = "https://sdk.cashfree.com/js/ui/2.0.0/cashfree.prod.js";

  const { sid } = useParams();
  useEffect(() => {
    const head = document.querySelector("head");
    const script = document.createElement("script");

    script.setAttribute("src", url);
    head.appendChild(script);

    return () => {
      head.removeChild(script);
    };
  }, [url]);

  useEffect(() => {
    if (sid) {
      window.RedirectToCashfree(sid);
    }
  }, [sid]);

  return <div></div>;
}

export default PaymentGatewayRspV2;
